export default {
  free: 'GRATIS',
  save: 'Oszczędź {{amount}}',
};
